import { Stack, Typography } from "@mui/material";
import { useBorder } from "@pulse/shared-components";
import {
  useCornerRadius,
  useFoundationColorTokens,
  useSpacing,
  useTypography,
} from "@surya-digital/leo-reactjs-material-ui";
import React from "react";

interface ReadOnlyFieldContainerProps extends React.PropsWithChildren {
  label: string;
  required?: boolean;
  helperText?: string;
  error?: boolean;
}

export const ReadOnlyFieldContainer: React.FC<ReadOnlyFieldContainerProps> = ({
  label,
  children,
}) => {
  const spacing = useSpacing();
  const typography = useTypography();
  const tokens = useFoundationColorTokens();
  const border = useBorder();
  const cornerRadius = useCornerRadius();

  return (
    <Stack gap={spacing.spaceXXS} width="100%">
      <Typography color={tokens.label} {...typography.s2}>
        {label}
      </Typography>

      <Stack
        border={border.default}
        borderRadius={cornerRadius.radiusXS}
        paddingInline={spacing.spaceMD}
        paddingBlock={spacing.spaceSM}
        justifyContent="center"
        overflow="auto"
        bgcolor={tokens.backgroundPageSubtle}
      >
        <Typography color={tokens.label} {...typography.b1} whiteSpace="nowrap">
          {children}
        </Typography>
      </Stack>
    </Stack>
  );
};
